module.exports = {
    en: {
        "sum.saves_percentage": "saves_percentage",
        "sum.aerial_won": "aerial_won",
        "sum.shot_off_target": "shot_off_target",
        "sum.crosses_18yard": "crosses_18yard",
        "sum.interception": "interception",
        "sum.long_pass_own_to_opp": "long_pass_own_to_opp",
        "sum.poss_won_att_3rd": "poss_won_att_3rd",
        "sum.accurate_pass": "accurate_pass",
        "sum.total_contest": "total_contest",
        "sum.total_offside": "total_offside",
        "sum.att_hd_miss": "att_hd_miss",
        "sum.interception_won": "interception_won",
        "sum.total_att_assist": "total_att_assist",
        "sum.accurate_layoffs": "accurate_layoffs",
        "sum.backward_pass": "backward_pass",
        "sum.accurate_cross": "accurate_cross",
        "sum.leftside_pass": "leftside_pass",
        "sum.keeper_throws": "keeper_throws",
        "sum.blocked_pass": "blocked_pass",
        "sum.leftside_pass_percentage": "leftside_pass_percentage",
        "sum.ball_recovery": "ball_recovery",
        "sum.crosses_18yardplus": "crosses_18yardplus",
        "sum.att_bx_centre": "att_bx_centre",
        "sum.total_long_balls": "total_long_balls",
        "sum.challenge_lost": "challenge_lost",
        "sum.total_throws": "total_throws",
        "sum.subs_made": "subs_made",
        "sum.accurate_chipped_pass": "accurate_chipped_pass",
        "sum.passes_left": "passes_left",
        "sum.attempted_tackle_foul": "attempted_tackle_foul",
        "sum.touches": "touches",
        "sum.accurate_launches": "accurate_launches",
        "sum.att_miss_left": "att_miss_left",
        "sum.att_blocked_total": "att_blocked_total",
        "sum.total_cross_nocorner": "total_cross_nocorner",
        "sum.effective_clearance": "effective_clearance",
        "sum.total_clearance": "total_clearance",
        "sum.touches_in_opp_box": "touches_in_opp_box",
        "sum.saved_obox": "saved_obox",
        "sum.total_flick_on": "total_flick_on",
        "sum.fouled_final_third": "fouled_final_third",
        "sum.total_yel_card": "total_yel_card",
        "sum.total_tackle": "total_tackle",
        "sum.goal_kicks": "goal_kicks",
        "sum.shield_ball_oop": "shield_ball_oop",
        "sum.fwd_pass_percentage": "fwd_pass_percentage",
        "sum.successful_put_through": "successful_put_through",
        "sum.total_back_zone_pass": "total_back_zone_pass",
        "sum.total_corners_intobox": "total_corners_intobox",
        "sum.long_pass_own_to_opp_success": "long_pass_own_to_opp_success",
        "sum.head_clearance": "head_clearance",
        "sum.backward_pass_percentage": "backward_pass_percentage",
        "sum.att_bx_left": "att_bx_left",
        "sum.punches": "punches",
        "sum.diving_save": "diving_save",
        "sum.accurate_keeper_sweeper": "accurate_keeper_sweeper",
        "sum.att_rf_total": "att_rf_total",
        "sum.att_cmiss_high_left": "att_cmiss_high_left",
        "sum.accurate_flick_on": "accurate_flick_on",
        "sum.poss_lost_ctrl": "poss_lost_ctrl",
        "sum.fk_foul_lost": "fk_foul_lost",
        "sum.total_scoring_att": "total_scoring_att",
        "sum.total_cross": "total_cross",
        "sum.att_ibox_miss": "att_ibox_miss",
        "sum.ground_duels_won": "ground_duels_won",
        "sum.accurate_fwd_zone_pass": "accurate_fwd_zone_pass",
        "sum.poss_lost_all": "poss_lost_all",
        "sum.successful_final_third_passes": "successful_final_third_passes",
        "sum.accurate_throws": "accurate_throws",
        "sum.attempts_conceded_ibox": "attempts_conceded_ibox",
        "sum.att_bx_right": "att_bx_right",
        "sum.duel_won": "duel_won",
        "sum.total_pass": "total_pass",
        "sum.effective_head_clearance": "effective_head_clearance",
        "sum.attempts_conceded_obox": "attempts_conceded_obox",
        "sum.won_tackle": "won_tackle",
        "sum.goals_shots_percentage": "goals_shots_percentage",
        "sum.poss_won_mid_3rd": "poss_won_mid_3rd",
        "sum.duel_lost": "duel_lost",
        "sum.won_contest": "won_contest",
        "sum.outfielder_block": "outfielder_block",
        "sum.accurate_back_zone_pass": "accurate_back_zone_pass",
        "sum.att_lf_total": "att_lf_total",
        "sum.interceptions_in_box": "interceptions_in_box",
        "sum.total_through_ball": "total_through_ball",
        "sum.rightside_pass": "rightside_pass",
        "sum.accurate_corners_intobox": "accurate_corners_intobox",
        "sum.passes_right": "passes_right",
        "sum.corner_taken": "corner_taken",
        "sum.fwd_pass": "fwd_pass",
        "sum.total_fwd_zone_pass": "total_fwd_zone_pass",
        "sum.total_layoffs": "total_layoffs",
        "sum.lost_corners": "lost_corners",
        "sum.att_hd_total": "att_hd_total",
        "sum.clean_sheet": "clean_sheet",
        "sum.att_miss_high": "att_miss_high",
        "sum.saved_ibox": "saved_ibox",
        "sum.formation_used": "formation_used",
        "sum.put_through": "put_through",
        "sum.effective_blocked_cross": "effective_blocked_cross",
        "sum.final_third_entries": "final_third_entries",
        "sum.dispossessed": "dispossessed",
        "sum.total_final_third_passes": "total_final_third_passes",
        "sum.accurate_long_balls_percentage": "accurate_long_balls_percentage",
        "sum.open_play_pass": "open_play_pass",
        "sum.won_corners": "won_corners",
        "sum.att_miss_high_left": "att_miss_high_left",
        "sum.accurate_long_balls": "accurate_long_balls",
        "sum.accurate_goal_kicks": "accurate_goal_kicks",
        "sum.saves": "saves",
        "sum.accurate_cross_nocorner": "accurate_cross_nocorner",
        "sum.successful_open_play_pass": "successful_open_play_pass",
        "sum.pen_area_entries": "pen_area_entries",
        "sum.total_keeper_sweeper": "total_keeper_sweeper",
        "sum.att_assist_setplay": "att_assist_setplay",
        "sum.accurate_pass_percentage": "accurate_pass_percentage",
        "sum.accurate_fwd_zone_percentage": "accurate_fwd_zone_percentage",
        "sum.freekick_cross": "freekick_cross",
        "sum.unsuccessful_touch": "unsuccessful_touch",
        "sum.rightside_pass_percentage": "rightside_pass_percentage",
        "sum.blocked_cross": "blocked_cross",
        "sum.aerial_lost": "aerial_lost",
        "sum.total_launches": "total_launches",
        "sum.offtarget_att_assist": "offtarget_att_assist",
        "sum.accurate_back_zone_percentage": "accurate_back_zone_percentage",
        "sum.fk_foul_won": "fk_foul_won",
        "sum.poss_won_def_3rd": "poss_won_def_3rd",
        "sum.possession_percentage": "possession_percentage",
        "sum.attempts_ibox": "attempts_ibox",
        "sum.accurate_keeper_throws": "accurate_keeper_throws",
        "sum.accurate_freekick_cross": "accurate_freekick_cross",
        "sum.total_chipped_pass": "total_chipped_pass",
        "sum.matches_played": "matches_played",
        "sum.att_assist_openplay": "att_assist_openplay",
        "sum.att_openplay": "att_openplay",
        "sum.overrun": "overrun",
        "sum.att_cmiss_high": "att_cmiss_high",
        "sum.att_obx_centre": "att_obx_centre",
        "sum.att_freekick_total": "att_freekick_total",
        "sum.att_rf_target": "att_rf_target",
        "sum.att_sv_low_left": "att_sv_low_left",
        "sum.attempts_obox": "attempts_obox",
        "sum.att_ibox_target": "att_ibox_target",
        "sum.ontarget_scoring_att": "ontarget_scoring_att",
        "sum.att_obox_blocked": "att_obox_blocked",
        "sum.ontarget_att_assist": "ontarget_att_assist",
        "sum.big_chance_created": "big_chance_created",
        "sum.att_obox_target": "att_obox_target",
        "sum.att_obox_miss": "att_obox_miss",
        "sum.blocked_scoring_att": "blocked_scoring_att",
        "sum.big_chance_missed": "big_chance_missed",
        "sum.att_lf_target": "att_lf_target",
        "sum.att_freekick_miss": "att_freekick_miss",
        "sum.total_pull_back": "total_pull_back",
        "sum.att_ibox_blocked": "att_ibox_blocked",
        "sum.hit_woodwork": "hit_woodwork",
        "sum.att_freekick_target": "att_freekick_target",
        "sum.att_post_left": "att_post_left",
        "sum.att_miss_right": "att_miss_right",
        "sum.att_cmiss_right": "att_cmiss_right",
        "sum.goals_conceded": "goals_conceded",
        "sum.goals_conceded_ibox": "goals_conceded_ibox",
        "sum.att_ibox_post": "att_ibox_post",
        "sum.att_cmiss_left": "att_cmiss_left",
        "sum.att_setpiece": "att_setpiece",
        "sum.att_sv_low_centre": "att_sv_low_centre",
        "sum.att_hd_target": "att_hd_target",
        "sum.att_sv_high_centre": "att_sv_high_centre",
        "sum.accurate_through_ball": "accurate_through_ball",
        "sum.total_high_claim": "total_high_claim",
        "sum.post_scoring_att": "post_scoring_att",
        "sum.att_sv_low_right": "att_sv_low_right",
        "sum.good_high_claim": "good_high_claim",
        "sum.first_half_goals": "first_half_goals",
        "sum.six_yard_block": "six_yard_block",
        "sum.goal_assist_intentional": "goal_assist_intentional",
        "sum.big_chance_scored": "big_chance_scored",
        "sum.goals": "goals",
        "sum.att_goal_low_centre": "att_goal_low_centre",
        "sum.att_hd_goal": "att_hd_goal",
        "sum.goal_assist_deadball": "goal_assist_deadball",
        "sum.att_goal_high_right": "att_goal_high_right",
        "sum.att_ibox_goal": "att_ibox_goal",
        "sum.goal_assist_openplay": "goal_assist_openplay",
        "sum.att_sv_high_left": "att_sv_high_left",
        "sum.goals_openplay": "goals_openplay",
        "sum.goal_assist": "goal_assist",
        "sum.midfielder_goals": "midfielder_goals",
        "sum.forward_goals": "forward_goals",
        "sum.att_rf_goal": "att_rf_goal",
        "sum.att_one_on_one": "att_one_on_one",
        "sum.goal_assist_setplay": "goal_assist_setplay",
        "sum.hand_ball": "hand_ball",
        "sum.att_goal_low_left": "att_goal_low_left",
        "sum.att_miss_high_right": "att_miss_high_right",
        "sum.att_lf_goal": "att_lf_goal",
        "sum.att_goal_low_right": "att_goal_low_right",
        "sum.defender_goals": "defender_goals",
        "sum.shot_fastbreak": "shot_fastbreak",
        "sum.total_fastbreak": "total_fastbreak",
        "sum.att_fastbreak": "att_fastbreak",
        "sum.att_pen_goal": "att_pen_goal",
        "sum.penalty_won": "penalty_won",
        "sum.att_goal_high_centre": "att_goal_high_centre",
        "sum.penalty_faced": "penalty_faced",
        "sum.att_post_high": "att_post_high",
        "sum.penalty_conceded": "penalty_conceded",
        "sum.accurate_pull_back": "accurate_pull_back",
        "sum.second_yellow": "second_yellow",
        "sum.pen_goals_conceded": "pen_goals_conceded",
        "sum.total_red_card": "total_red_card",
        "sum.att_hd_post": "att_hd_post",
        "sum.clearance_off_line": "clearance_off_line",
        "sum.penalty_save": "penalty_save",
        "sum.att_sv_high_right": "att_sv_high_right",
        "sum.att_cmiss_high_right": "att_cmiss_high_right",
        "sum.pts_gained_losing_pos": "pts_gained_losing_pos",
        "sum.att_obox_goal": "att_obox_goal",
        "sum.goals_conceded_obox": "goals_conceded_obox",
        "sum.pts_dropped_winning_pos": "pts_dropped_winning_pos",
        "sum.att_pen_target": "att_pen_target",
        "sum.att_goal_high_left": "att_goal_high_left",
        "sum.att_lg_centre": "att_lg_centre",
        "sum.att_post_right": "att_post_right",
        "sum.att_obxd_right": "att_obxd_right",
        "sum.error_lead_to_shot": "error_lead_to_shot",
        "sum.att_obox_post": "att_obox_post",
        "sum.att_freekick_post": "att_freekick_post",
        "sum.last_man_tackle": "last_man_tackle",
        "sum.own_goals": "own_goals",
        "sum.att_ibox_own_goal": "att_ibox_own_goal",
        "sum.att_freekick_goal": "att_freekick_goal",
        "sum.foul_throw_in": "foul_throw_in",
        "sum.own_goal_accrued": "own_goal_accrued",
        "sum.contentious_decision": "contentious_decision",
        "sum.error_lead_to_goal": "error_lead_to_goal",
        "sum.att_obx_right": "att_obx_right",
        "sum.goal_fastbreak": "goal_fastbreak",
        "sum.att_obxd_left": "att_obxd_left",
        "sum.att_obx_left": "att_obx_left",
        "sum.att_obp_goal": "att_obp_goal",
        "sum.dangerous_play": "dangerous_play",
        "sum.keeper_pick_up": "keeper_pick_up",
        "sum.cross_not_claimed": "cross_not_claimed",
        "sum.dive_catch": "dive_catch",
        "sum.assist_penalty_won": "assist_penalty_won",
        "sum.fouls": "fouls",
        "sum.dive_save": "dive_save",
        "sum.assist_free_kick_won": "assist_free_kick_won",
        "sum.assist_pass_lost": "assist_pass_lost",
        "sum.game_started": "game_started",
        "sum.stand_save": "stand_save",
        "sum.sub_in": "sub_in",
        "sum.starting_eleven": "starting_eleven",
        "sum.total_sub_off": "total_sub_off",
        "sum.sub_off": "sub_off",
        "sum.total_sub_on": "total_sub_on",
        "sum.formation_place": "formation_place",
        "sum.assist_own_goal": "assist_own_goal",
        "sum.starting_bench": "starting_bench",
        "sum.red_card": "red_card",
        "sum.assist_attempt_saved": "assist_attempt_saved",
        "sum.assist_blocked_shot": "assist_blocked_shot",
        "sum.total_shots_on_goal_opponent": "total_shots_on_goal_opponent",
        "sum.offside_provoked": "offside_provoked",
        "sum.stand_catch": "stand_catch",
        "sum.turnover": "turnover",
        "sum.second_goal_assist": "second_goal_assist",
        "sum.assist_post": "assist_post",
        "sum.gk_smother": "gk_smother",
        "sum.was_fouled": "was_fouled",
        "sum.mins_played": "mins_played",
        "sum.yellow_card": "yellow_card",
        "sum.head_pass": "head_pass",

        "avg.saves_percentage": "saves_percentage",
        "avg.aerial_won": "aerial_won",
        "avg.shot_off_target": "shot_off_target",
        "avg.crosses_18yard": "crosses_18yard",
        "avg.interception": "interception",
        "avg.long_pass_own_to_opp": "long_pass_own_to_opp",
        "avg.poss_won_att_3rd": "poss_won_att_3rd",
        "avg.accurate_pass": "accurate_pass",
        "avg.total_contest": "total_contest",
        "avg.total_offside": "total_offside",
        "avg.att_hd_miss": "att_hd_miss",
        "avg.interception_won": "interception_won",
        "avg.total_att_assist": "total_att_assist",
        "avg.accurate_layoffs": "accurate_layoffs",
        "avg.backward_pass": "backward_pass",
        "avg.accurate_cross": "accurate_cross",
        "avg.leftside_pass": "leftside_pass",
        "avg.keeper_throws": "keeper_throws",
        "avg.blocked_pass": "blocked_pass",
        "avg.leftside_pass_percentage": "leftside_pass_percentage",
        "avg.ball_recovery": "ball_recovery",
        "avg.crosses_18yardplus": "crosses_18yardplus",
        "avg.att_bx_centre": "att_bx_centre",
        "avg.total_long_balls": "total_long_balls",
        "avg.challenge_lost": "challenge_lost",
        "avg.total_throws": "total_throws",
        "avg.subs_made": "subs_made",
        "avg.accurate_chipped_pass": "accurate_chipped_pass",
        "avg.passes_left": "passes_left",
        "avg.attempted_tackle_foul": "attempted_tackle_foul",
        "avg.touches": "touches",
        "avg.accurate_launches": "accurate_launches",
        "avg.att_miss_left": "att_miss_left",
        "avg.att_blocked_total": "att_blocked_total",
        "avg.total_cross_nocorner": "total_cross_nocorner",
        "avg.effective_clearance": "effective_clearance",
        "avg.total_clearance": "total_clearance",
        "avg.touches_in_opp_box": "touches_in_opp_box",
        "avg.saved_obox": "saved_obox",
        "avg.total_flick_on": "total_flick_on",
        "avg.fouled_final_third": "fouled_final_third",
        "avg.total_yel_card": "total_yel_card",
        "avg.total_tackle": "total_tackle",
        "avg.goal_kicks": "goal_kicks",
        "avg.shield_ball_oop": "shield_ball_oop",
        "avg.fwd_pass_percentage": "fwd_pass_percentage",
        "avg.successful_put_through": "successful_put_through",
        "avg.total_back_zone_pass": "total_back_zone_pass",
        "avg.total_corners_intobox": "total_corners_intobox",
        "avg.long_pass_own_to_opp_success": "long_pass_own_to_opp_success",
        "avg.head_clearance": "head_clearance",
        "avg.backward_pass_percentage": "backward_pass_percentage",
        "avg.att_bx_left": "att_bx_left",
        "avg.punches": "punches",
        "avg.diving_save": "diving_save",
        "avg.accurate_keeper_sweeper": "accurate_keeper_sweeper",
        "avg.att_rf_total": "att_rf_total",
        "avg.att_cmiss_high_left": "att_cmiss_high_left",
        "avg.accurate_flick_on": "accurate_flick_on",
        "avg.poss_lost_ctrl": "poss_lost_ctrl",
        "avg.fk_foul_lost": "fk_foul_lost",
        "avg.total_scoring_att": "total_scoring_att",
        "avg.total_cross": "total_cross",
        "avg.att_ibox_miss": "att_ibox_miss",
        "avg.ground_duels_won": "ground_duels_won",
        "avg.accurate_fwd_zone_pass": "accurate_fwd_zone_pass",
        "avg.poss_lost_all": "poss_lost_all",
        "avg.successful_final_third_passes": "successful_final_third_passes",
        "avg.accurate_throws": "accurate_throws",
        "avg.attempts_conceded_ibox": "attempts_conceded_ibox",
        "avg.att_bx_right": "att_bx_right",
        "avg.duel_won": "duel_won",
        "avg.total_pass": "total_pass",
        "avg.effective_head_clearance": "effective_head_clearance",
        "avg.attempts_conceded_obox": "attempts_conceded_obox",
        "avg.won_tackle": "won_tackle",
        "avg.goals_shots_percentage": "goals_shots_percentage",
        "avg.poss_won_mid_3rd": "poss_won_mid_3rd",
        "avg.duel_lost": "duel_lost",
        "avg.won_contest": "won_contest",
        "avg.outfielder_block": "outfielder_block",
        "avg.accurate_back_zone_pass": "accurate_back_zone_pass",
        "avg.att_lf_total": "att_lf_total",
        "avg.interceptions_in_box": "interceptions_in_box",
        "avg.total_through_ball": "total_through_ball",
        "avg.rightside_pass": "rightside_pass",
        "avg.accurate_corners_intobox": "accurate_corners_intobox",
        "avg.passes_right": "passes_right",
        "avg.corner_taken": "corner_taken",
        "avg.fwd_pass": "fwd_pass",
        "avg.total_fwd_zone_pass": "total_fwd_zone_pass",
        "avg.total_layoffs": "total_layoffs",
        "avg.lost_corners": "lost_corners",
        "avg.att_hd_total": "att_hd_total",
        "avg.clean_sheet": "clean_sheet",
        "avg.att_miss_high": "att_miss_high",
        "avg.saved_ibox": "saved_ibox",
        "avg.formation_used": "formation_used",
        "avg.put_through": "put_through",
        "avg.effective_blocked_cross": "effective_blocked_cross",
        "avg.final_third_entries": "final_third_entries",
        "avg.dispossessed": "dispossessed",
        "avg.total_final_third_passes": "total_final_third_passes",
        "avg.accurate_long_balls_percentage": "accurate_long_balls_percentage",
        "avg.open_play_pass": "open_play_pass",
        "avg.won_corners": "won_corners",
        "avg.att_miss_high_left": "att_miss_high_left",
        "avg.accurate_long_balls": "accurate_long_balls",
        "avg.accurate_goal_kicks": "accurate_goal_kicks",
        "avg.saves": "saves",
        "avg.accurate_cross_nocorner": "accurate_cross_nocorner",
        "avg.successful_open_play_pass": "successful_open_play_pass",
        "avg.pen_area_entries": "pen_area_entries",
        "avg.total_keeper_sweeper": "total_keeper_sweeper",
        "avg.att_assist_setplay": "att_assist_setplay",
        "avg.accurate_pass_percentage": "accurate_pass_percentage",
        "avg.accurate_fwd_zone_percentage": "accurate_fwd_zone_percentage",
        "avg.freekick_cross": "freekick_cross",
        "avg.unsuccessful_touch": "unsuccessful_touch",
        "avg.rightside_pass_percentage": "rightside_pass_percentage",
        "avg.blocked_cross": "blocked_cross",
        "avg.aerial_lost": "aerial_lost",
        "avg.total_launches": "total_launches",
        "avg.offtarget_att_assist": "offtarget_att_assist",
        "avg.accurate_back_zone_percentage": "accurate_back_zone_percentage",
        "avg.fk_foul_won": "fk_foul_won",
        "avg.poss_won_def_3rd": "poss_won_def_3rd",
        "avg.possession_percentage": "possession_percentage",
        "avg.attempts_ibox": "attempts_ibox",
        "avg.accurate_keeper_throws": "accurate_keeper_throws",
        "avg.accurate_freekick_cross": "accurate_freekick_cross",
        "avg.total_chipped_pass": "total_chipped_pass",
        "avg.matches_played": "matches_played",
        "avg.att_assist_openplay": "att_assist_openplay",
        "avg.att_openplay": "att_openplay",
        "avg.overrun": "overrun",
        "avg.att_cmiss_high": "att_cmiss_high",
        "avg.att_obx_centre": "att_obx_centre",
        "avg.att_freekick_total": "att_freekick_total",
        "avg.att_rf_target": "att_rf_target",
        "avg.att_sv_low_left": "att_sv_low_left",
        "avg.attempts_obox": "attempts_obox",
        "avg.att_ibox_target": "att_ibox_target",
        "avg.ontarget_scoring_att": "ontarget_scoring_att",
        "avg.att_obox_blocked": "att_obox_blocked",
        "avg.ontarget_att_assist": "ontarget_att_assist",
        "avg.big_chance_created": "big_chance_created",
        "avg.att_obox_target": "att_obox_target",
        "avg.att_obox_miss": "att_obox_miss",
        "avg.blocked_scoring_att": "blocked_scoring_att",
        "avg.big_chance_missed": "big_chance_missed",
        "avg.att_lf_target": "att_lf_target",
        "avg.att_freekick_miss": "att_freekick_miss",
        "avg.total_pull_back": "total_pull_back",
        "avg.att_ibox_blocked": "att_ibox_blocked",
        "avg.hit_woodwork": "hit_woodwork",
        "avg.att_freekick_target": "att_freekick_target",
        "avg.att_post_left": "att_post_left",
        "avg.att_miss_right": "att_miss_right",
        "avg.att_cmiss_right": "att_cmiss_right",
        "avg.goals_conceded": "goals_conceded",
        "avg.goals_conceded_ibox": "goals_conceded_ibox",
        "avg.att_ibox_post": "att_ibox_post",
        "avg.att_cmiss_left": "att_cmiss_left",
        "avg.att_setpiece": "att_setpiece",
        "avg.att_sv_low_centre": "att_sv_low_centre",
        "avg.att_hd_target": "att_hd_target",
        "avg.att_sv_high_centre": "att_sv_high_centre",
        "avg.accurate_through_ball": "accurate_through_ball",
        "avg.total_high_claim": "total_high_claim",
        "avg.post_scoring_att": "post_scoring_att",
        "avg.att_sv_low_right": "att_sv_low_right",
        "avg.good_high_claim": "good_high_claim",
        "avg.first_half_goals": "first_half_goals",
        "avg.six_yard_block": "six_yard_block",
        "avg.goal_assist_intentional": "goal_assist_intentional",
        "avg.big_chance_scored": "big_chance_scored",
        "avg.goals": "goals",
        "avg.att_goal_low_centre": "att_goal_low_centre",
        "avg.att_hd_goal": "att_hd_goal",
        "avg.goal_assist_deadball": "goal_assist_deadball",
        "avg.att_goal_high_right": "att_goal_high_right",
        "avg.att_ibox_goal": "att_ibox_goal",
        "avg.goal_assist_openplay": "goal_assist_openplay",
        "avg.att_sv_high_left": "att_sv_high_left",
        "avg.goals_openplay": "goals_openplay",
        "avg.goal_assist": "goal_assist",
        "avg.midfielder_goals": "midfielder_goals",
        "avg.forward_goals": "forward_goals",
        "avg.att_rf_goal": "att_rf_goal",
        "avg.att_one_on_one": "att_one_on_one",
        "avg.goal_assist_setplay": "goal_assist_setplay",
        "avg.hand_ball": "hand_ball",
        "avg.att_goal_low_left": "att_goal_low_left",
        "avg.att_miss_high_right": "att_miss_high_right",
        "avg.att_lf_goal": "att_lf_goal",
        "avg.att_goal_low_right": "att_goal_low_right",
        "avg.defender_goals": "defender_goals",
        "avg.shot_fastbreak": "shot_fastbreak",
        "avg.total_fastbreak": "total_fastbreak",
        "avg.att_fastbreak": "att_fastbreak",
        "avg.att_pen_goal": "att_pen_goal",
        "avg.penalty_won": "penalty_won",
        "avg.att_goal_high_centre": "att_goal_high_centre",
        "avg.penalty_faced": "penalty_faced",
        "avg.att_post_high": "att_post_high",
        "avg.penalty_conceded": "penalty_conceded",
        "avg.accurate_pull_back": "accurate_pull_back",
        "avg.second_yellow": "second_yellow",
        "avg.pen_goals_conceded": "pen_goals_conceded",
        "avg.total_red_card": "total_red_card",
        "avg.att_hd_post": "att_hd_post",
        "avg.clearance_off_line": "clearance_off_line",
        "avg.penalty_save": "penalty_save",
        "avg.att_sv_high_right": "att_sv_high_right",
        "avg.att_cmiss_high_right": "att_cmiss_high_right",
        "avg.pts_gained_losing_pos": "pts_gained_losing_pos",
        "avg.att_obox_goal": "att_obox_goal",
        "avg.goals_conceded_obox": "goals_conceded_obox",
        "avg.pts_dropped_winning_pos": "pts_dropped_winning_pos",
        "avg.att_pen_target": "att_pen_target",
        "avg.att_goal_high_left": "att_goal_high_left",
        "avg.att_lg_centre": "att_lg_centre",
        "avg.att_post_right": "att_post_right",
        "avg.att_obxd_right": "att_obxd_right",
        "avg.error_lead_to_shot": "error_lead_to_shot",
        "avg.att_obox_post": "att_obox_post",
        "avg.att_freekick_post": "att_freekick_post",
        "avg.last_man_tackle": "last_man_tackle",
        "avg.own_goals": "own_goals",
        "avg.att_ibox_own_goal": "att_ibox_own_goal",
        "avg.att_freekick_goal": "att_freekick_goal",
        "avg.foul_throw_in": "foul_throw_in",
        "avg.own_goal_accrued": "own_goal_accrued",
        "avg.contentious_decision": "contentious_decision",
        "avg.error_lead_to_goal": "error_lead_to_goal",
        "avg.att_obx_right": "att_obx_right",
        "avg.goal_fastbreak": "goal_fastbreak",
        "avg.att_obxd_left": "att_obxd_left",
        "avg.att_obx_left": "att_obx_left",
        "avg.att_obp_goal": "att_obp_goal",
        "avg.dangerous_play": "dangerous_play",
        "avg.keeper_pick_up": "keeper_pick_up",
        "avg.cross_not_claimed": "cross_not_claimed",
        "avg.dive_catch": "dive_catch",
        "avg.assist_penalty_won": "assist_penalty_won",
        "avg.fouls": "fouls",
        "avg.dive_save": "dive_save",
        "avg.assist_free_kick_won": "assist_free_kick_won",
        "avg.assist_pass_lost": "assist_pass_lost",
        "avg.game_started": "game_started",
        "avg.stand_save": "stand_save",
        "avg.sub_in": "sub_in",
        "avg.starting_eleven": "starting_eleven",
        "avg.total_sub_off": "total_sub_off",
        "avg.sub_off": "sub_off",
        "avg.total_sub_on": "total_sub_on",
        "avg.formation_place": "formation_place",
        "avg.assist_own_goal": "assist_own_goal",
        "avg.starting_bench": "starting_bench",
        "avg.red_card": "red_card",
        "avg.assist_attempt_saved": "assist_attempt_saved",
        "avg.assist_blocked_shot": "assist_blocked_shot",
        "avg.total_shots_on_goal_opponent": "total_shots_on_goal_opponent",
        "avg.offside_provoked": "offside_provoked",
        "avg.stand_catch": "stand_catch",
        "avg.turnover": "turnover",
        "avg.second_goal_assist": "second_goal_assist",
        "avg.assist_post": "assist_post",
        "avg.gk_smother": "gk_smother",
        "avg.was_fouled": "was_fouled",
        "avg.mins_played": "mins_played",
        "avg.yellow_card": "yellow_card",
        "avg.head_pass": "head_pass"
    },
    da: {},
    no: {}
};

//var a = {};



/** WEBPACK FOOTER **
 ** ../src/widgets/i18/default/i18.opta.js
 **/